import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-application-development-service',
  templateUrl: './web-application-development-service.component.html',
  styleUrls: ['./web-application-development-service.component.scss']
})
export class WebApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
